import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    padding: theme.spacing(0, 3),
  },
  header: {
  },
  content: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 2),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  textbox: {
    width: 'fit-content',
    padding: theme.spacing(2, 6),
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.facet.lightGray,
    color: theme.palette.facet.darkGray,
    fontStyle: 'italic',
  },
});

function ViewSectionLayout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      <OnboardingPlannerViewSectionHeader
        className={classes.header}
        title={resource.attr('title')}
      />
      <Box className={classes.content}>
        <div className={classes.textbox}>
          <Typography>Section not complete</Typography>
        </div>
      </Box>
    </div>
  );
}

ViewSectionLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

ViewSectionLayout.defaultProps = {
};

export default withStyles(styles)(ViewSectionLayout);
